module.exports = __webpack_public_path__ + "static/media/Gilroy-UltraLight-Italic.aa409df4.eot";